<template>
	<div class="r-d-form">
		<div class="box-card">
			<div style="margin:40px 0px;padding-left: 13px;border-left: 2px solid #EC5A35;">
				我需要研发
			</div>

			<el-form ref="form" :model="formData" label-width="120px" @submit.native.prevent="submitForm">
				<el-form-item label="公司名称" required>
					<el-input v-model="formData.company" placeholder="请填写您的公司名称"></el-input>
				</el-form-item>
				<el-form-item label="联系人" required>
					<el-input v-model="formData.user_name" placeholder="请填写您的名字"></el-input>
				</el-form-item>
				<el-form-item label="联系方式" required>
					<el-input v-model="formData.user_phone" placeholder="请填写您的手机号"></el-input>
				</el-form-item>
				<el-form-item label="服务需求" required>
					<div class="service-demand" v-for="(item,index) in list" :key="index">
						<span style="margin-right: 20px;">{{item.name}}</span>
						<el-checkbox-group v-model="labels">
							<el-checkbox :label="item2.name" v-for="(item2,index2) in item.childlist"></el-checkbox>
						</el-checkbox-group>
					</div>
				</el-form-item>
				<el-form-item label="需求详述">
					<el-input type="textarea" v-model="formData.content" placeholder="请描述您的详细需求"></el-input>
				</el-form-item>
				<el-form-item label="附件">
					<el-upload :action="$url+'/api/common/upload'" multiple :on-preview="handlePreview" :on-remove="handleRemove"
						:file-list="fileList" :on-success="uploadSuccess" list-type="text" :limit="9">
						<el-button slot="trigger" size="small">+ 添加附件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item style="text-align: center;">
					<el-button type="primary"
						style="background-color: #EC5A35;border: 0px;width: 260px;height: 48px;border-radius: 12px;"
						@click="submitForm">提交</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formData: {
					admin_id: '',
					type: 0,
					company: '',
					user_name: '',
					user_phone: '',
					labels: [],
					files: [],
					content: ''
				},
				list: [],
				files: [],
				labels: [],
				fileList: []
			};
		},
		mounted() {
			this.formData.admin_id = this.$route.query.admin_id;
			this.loadLabels();
		},
		methods: {
			// 服务详情
			loadLabels() {
				this.$http.get('/index/category?type=yanfa').then(res => {
					this.list = res.data
					console.log(this.list)
				}).catch(err => {
					console.error('请求失败', err);
				});
			},
			uploadSuccess(response, file, fileList){
				this.files.push(response.data.url)
			},
			submitForm() {
			
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.formData.files = this.files.toString();
						this.formData.labels = this.labels.toString();
						this.$http.post('/index/demandSubmit', this.formData).then(res => {
							if(res.code == 1) {
								window.location.href = '/complete';
							} else {
								this.$message(res.msg);
							}
							console.log(this)
						}).catch(err => {
							console.error('请求失败', err);
						});
						console.log(this.formData);
						// 这里可以添加实际的提交逻辑，比如发送数据到后端接口
					} else {
						console.log('表单验证未通过');
						return false;
					}
				});
			},
			handlePreview(file) {
				console.log(file);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			}
		}
	};
</script>
<style>
	.el-form-item__label {
		text-align: left !important;
		/* 使用 !important 确保样式覆盖 */
	}
</style>
<style scoped>
	.r-d-form {
		min-height: 100vh;
		padding: 20px;
		background-color: #FAFAFA;
	}

	.box-card {
		width: 950px;
		margin: 0 auto;
	}

	.service-demand {
		display: flex;
		margin-bottom: 10px;
	}

	/deep/ .el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #EC5A35;
	}

	/deep/ .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
		border-color: #EC5A35;
		background-color: #EC5A35;
	}
</style>